module.exports = __webpack_public_path__ + "static/media/phone-chs.e74a8890.png";